export interface GetAliiNotificationCategoryResponse {
  id: number;
  type: NotificationType | undefined;
  code: string | undefined;
  name: string | undefined;
  description: string | undefined;
  parentCodeId: number | undefined | null;
  isVisibleInAdmin: boolean | undefined;
}

export enum NotificationType {
  Other = 'Other',
  Invoice = 'Invoice',
  PurchaseOrder = 'PurchaseOrder',
  ExpenseClaim = 'ExpenseClaim',
  CreditCardRec = 'CreditCardRec',
}
